module.exports = __webpack_public_path__ + "img/com.codeway.pixelup.f51b6da8.png";